import React from 'react';

export default function List({ height, className = null, children, gap = '0px', style = {}, fit = false, divider = null }) {
    return (
        <div className={`list ${className !== null ? className : ''}`} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            height,
            width: fit ? 'fit-content' : 'auto',
            ...style
        }}>
            { divider !== null ? React.Children.map(children, (child, index) => {
                return (
                    <>
                        { child }
                        { index !== children.length - 1 && divider }
                    </>
                )
            }) : children }
        </div>
    )
}